import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from 'primereact/button'

import { DocumentTitle } from '../components/DocumentTitle'

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <DocumentTitle title={t('notFound.title.title')} />

      <div className="min-h-screen flex align-content-center">
        <div className="flex flex-column flex-grow-1 align-items-center justify-content-center">
          <div className="flex flex-column sm:flex-row">
            <div className="text-5xl text-primary font-bold border-left-1 sm:border-right-1 sm:border-left-none px-3 pb-3 sm:pb-0">
              {t('notFound.content.code')}
            </div>
            <div className="flex flex-column border-left-1 sm:border-left-none border-primary px-3 gap-2">
              <div className="font-bold">{t('notFound.content.text')}</div>
              <div>{t('notFound.content.description')}</div>
              <div className="mt-4">
                <Link to="/" className="no-underline">
                  <Button>{t('notFound.content.back.label')}</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
